/*
 * DistributorService.js
 *
 * Author: Kevin Dench <kevin.dench@intellidata.net>
 * Author: IntelliData, Inc.
 * License: Proprietary
 * Version: 1.0
 * Copyright: 2017.
 */

/* @ngInject */
export default function DistributorService(NumberFormatterService, OctopartApiService) {
    'use strict';

    function findLowestNumber(numbers, property) {
        let lowest = Number.POSITIVE_INFINITY;
        let highest = Number.NEGATIVE_INFINITY;
        let tmp;
        const numberLen = numbers.length - 1;
        for (let i = numberLen; i >= 0; i--) {
            tmp = numbers[i][property];
            if (tmp < lowest) {
                lowest = tmp;
            }

            if (tmp > highest) {
                highest = tmp;
            }
        }
        return lowest;
    }

    function findMinOrderQtyAndPrice(prices, minOrderQty) {
        const pricesLen = prices.length - 1;
        let tmp;
        let minOrder;

        for (let i = pricesLen; i >= 0; i--) {
            tmp = prices[i].quantity;
            if (tmp === minOrderQty) {
                minOrder = prices[i];
                break;
            }
        }

        return minOrder;
    }

    function formatAvailability(number) {
        if (number !== undefined) {
            if (number !== 0) {
                return NumberFormatterService.shortFormatter(parseInt(number), 1) + '+';
            } else {
                return number;
            }
        } else {
            return 'Calculating...';
        }
    }

    function removeZeroQuantityDistributor(distributors) {
        if (!distributors) {
            return;
        }
        let i = distributors.length;

        let quantityExists = false;
        while (i--) {
            if (distributors[i].quantity > 0) {
                quantityExists = true;
            }
        }

        if (quantityExists) {
            i = distributors.length;
            while (i--) {
                if (distributors[i].quantity < 1) {
                    distributors.splice(i, 1);
                }
            }
        }
    }

    function displayAliases(uniquePart) {
        let displayAliases = null;
        const aliases = [];

        if (uniquePart.aliases !== undefined) {
            for (let i = 0; i < Math.min(uniquePart.aliases.length, 2); i++) {
                const alias = uniquePart.aliases[i].value.replace(/(\{[^;]*})/gi, '');

                if (alias != null && alias.length > 0) {
                    aliases.push(alias);
                }
            }
        }

        // If we're using superalias, the PN becomes the first alias
        if (uniquePart.superAlias != null && uniquePart.superAlias.length > 0) {
            aliases.unshift(uniquePart.uniquePn.replace(/(\{[^;]*})/gi, ''));
        }

        if (aliases.length > 0) {
            displayAliases = '(' + aliases.join(', ') + ')';
        }

        return displayAliases;
    }

    function getDefaultCountry(region, countries) {
        var country;
        var countryCode;
        if (region === 'ASIA') {
            countryCode = 'TW';
        } else if (region === 'AMERICA') {
            countryCode = 'US';
        } else {
            countryCode = 'GB';
        }
        for(var i=0;i< countries.length;++i) {
            if(countries[i].code === countryCode) {
                country = countries[i];
            }
        }
        return country;
    }

    function getDefaultCountryCode(region) {
        var countryCode;
        if (region === 'ASIA') {
            countryCode = 'TW';
        } else if (region === 'AMERICA') {
            countryCode = 'US';
        } else {
            countryCode = 'GB';
        }
        return countryCode;
    }

    function findDistributors(uniquePart, region, countryCode, callBack) {
        OctopartApiService.getOctopartDistInfoByCountry(uniquePart, countryCode, function (distributors) {
            removeZeroQuantityDistributor(distributors.octoParts);
            let highestMinimumOrderPrice;
            let localCurrency;
            const arraySize = distributors.octoParts.length;
            let totalParts = 0;
            let referenceObj = {
                price: 0
            };

            for (var i = 0; i < arraySize; i++) {
                distributors.octoParts[i].prices.isCollapsed = true;
                totalParts = (distributors.octoParts[i].quantity + totalParts);

                var arrayOfPrices = distributors.octoParts[i].prices.prices;
                var highestPrice = findMinOrderQtyAndPrice(arrayOfPrices, distributors.octoParts[i].minOrderQty);

                if (highestPrice !== undefined && referenceObj.price < highestPrice.price) {
                    highestPrice.currency = distributors.octoParts[i].prices.currency;
                    referenceObj = highestPrice;
                }
            }

            if (arraySize !== 0) {
                highestMinimumOrderPrice = referenceObj.price + ' ' + referenceObj.currency;
            } else {
                highestMinimumOrderPrice = '-.--';
            }

            if (distributors.userRegion.region === 'EMEA') {
                localCurrency = '€';
            } else if (distributors.userRegion.region === 'ASIA') {
                localCurrency = '¥';
            }
            callBack(distributors.octoParts, highestMinimumOrderPrice, localCurrency, totalParts);
        });
    }

    return {
        getAliasesForDisplay: displayAliases,
        removeZeroQuantityDistributor: removeZeroQuantityDistributor,
        formatLargeNumber: formatAvailability,
        findLowestNumber: findLowestNumber,
        findMinOrderQtyAndPrice: findMinOrderQtyAndPrice,
        getDefaultCountryCode: getDefaultCountryCode,
        getDefaultCountry: getDefaultCountry,
        findDistributors: findDistributors
    };
}
